// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import {
    getAllAdjustments as getAllAdjustmentsApi,
} from '../../helpers/';

import { adjustmentsApiResponseSuccess, adjustmentsApiResponseError } from './actions';
import { AdjustmentsActionTypes } from './constants';
import { adjustmentResponseToAdjustmentObject } from '../../helpers/mappers/adjustment';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

function* getAllAdjustments({ payload: { query } }) {
    try {
        const getAllAdjustmentsResponse = yield call(getAllAdjustmentsApi, query);
        const adjustments = getAllAdjustmentsResponse.data.map((adjustmentResponse) =>
            adjustmentResponseToAdjustmentObject(adjustmentResponse)
        );
        const pagination = { ...paginationHeadersResponse(getAllAdjustmentsResponse.headers), ...query };
        yield put(adjustmentsApiResponseSuccess(AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS, { adjustments, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(adjustmentsApiResponseError(AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS, error));
    }
}

export function* watchGetAllAdjustments(): any {
    yield takeLatest(AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS, getAllAdjustments);
}

function* adjustmentsLogSaga(): any {
    yield all([
        fork(watchGetAllAdjustments), 
    ]);
}

export default adjustmentsLogSaga;
